import { useParams } from 'react-router-dom';

import { useAccount } from '@/core/api/account';

export const useSelectedAccountSafely = () => {
	const { accountId: accountIdParam } = useParams<{ accountId: string }>();
	const accountId = accountIdParam ? Number(accountIdParam) : null;
	const { data: accountData, isError } = useAccount(accountId);
	return accountId && !isError ? accountData : null;
};
